import api from '../../api';
import store from '../../store';
import { setEnforceOtpConfig } from '../../store/app';

export const getOtps = async (params) => {
  const res = await api.get('otps', { params });

  const configured = !!res?.data?.data?.find(
    ({ method, is_setup }) => ['authenticator', 'sms', 'email'].includes(method) && is_setup
  );

  const is_2fa_enabled = store.getState()?.app?.company?.options?.is_2fa_enabled;

  if (!configured && is_2fa_enabled) store.dispatch(setEnforceOtpConfig(true));
  else if (configured && is_2fa_enabled) store.dispatch(setEnforceOtpConfig(false));

  return res;
};

export const viewOtp = (id, params) => api.get('otps/' + id, { params });

export const deleteOtp = (id, params) => api.delete('otps/' + id, params);
